import { api } from "@/lib/api";

export const osApi = {
  meta:      () => api.get("/ofr/meta").then(r => r.data),
  dashboard: () => api.get("/ofr/dashboard").then(r => r.data),
  analytics: () => api.get("/ofr/analytics").then(r => r.data),

  listLeads: (params) => api.get("/ofr/leads", { params }).then(r => r.data),
  pipeline:  () => api.get("/ofr/leads/pipeline").then(r => r.data),
  getLead:   (id) => api.get(`/ofr/leads/${id}`).then(r => r.data),
  createLead: (body) => api.post("/ofr/leads", body).then(r => r.data),
  updateLead: (id, body) => api.patch(`/ofr/leads/${id}`, body).then(r => r.data),
  moveStage: (id, stage) => api.patch(`/ofr/leads/${id}/stage`, { stage }).then(r => r.data),
  assign:    (id, assigned_agent) => api.patch(`/ofr/leads/${id}/assign`, { assigned_agent }).then(r => r.data),
  addNote:   (id, note) => api.post(`/ofr/leads/${id}/note`, { note }).then(r => r.data),
  contacted: (id) => api.post(`/ofr/leads/${id}/contacted`).then(r => r.data),
  deleteLead: (id) => api.delete(`/ofr/leads/${id}`).then(r => r.data),
  simulate:  () => api.post("/ofr/leads/simulate").then(r => r.data),

  listTeam: () => api.get("/ofr/team").then(r => r.data),
  createUser: (body) => api.post("/ofr/team", body).then(r => r.data),
  updateUser: (id, body) => api.patch(`/ofr/team/${id}`, body).then(r => r.data),
  deleteUser: (id) => api.delete(`/ofr/team/${id}`).then(r => r.data),

  listConnectors: () => api.get("/ofr/connectors").then(r => r.data),
  createConnector: (body) => api.post("/ofr/connectors", body).then(r => r.data),

  listLoans: (params) => api.get("/ofr/loans", { params }).then(r => r.data),
  createLoan: (body) => api.post("/ofr/loans", body).then(r => r.data),
  updateLoan: (id, body) => api.patch(`/ofr/loans/${id}`, body).then(r => r.data),

  listCalls: (lead_id) => api.get("/ofr/calls", { params: lead_id ? { lead_id } : {} }).then(r => r.data),
  logCall: (body) => api.post("/ofr/calls", body).then(r => r.data),
};

// ------- Formatters -------
export function formatINR(n) {
  if (n == null || isNaN(n)) return "—";
  const num = Number(n);
  if (num >= 10000000) return `₹${(num / 10000000).toFixed(2)} Cr`;
  if (num >= 100000) return `₹${(num / 100000).toFixed(2)} L`;
  return `₹${num.toLocaleString("en-IN")}`;
}

export function formatSecs(s) {
  if (s == null) return "—";
  if (s < 60) return `${s}s`;
  const m = Math.floor(s / 60);
  const rest = s % 60;
  if (m < 60) return `${m}m ${rest}s`;
  const h = Math.floor(m / 60);
  const mm = m % 60;
  return `${h}h ${mm}m`;
}

export function slaClass(status) {
  return {
    "Responded": "os-sla-responded",
    "Pending": "os-sla-pending",
    "At Risk": "os-sla-atrisk",
    "Breached": "os-sla-breached",
  }[status] || "os-sla-pending";
}

export function statusColor(s) {
  return {
    Hot: "os-badge-hot",
    Warm: "os-badge-amber",
    Cold: "os-badge-cold",
  }[s] || "os-badge-grey";
}

export function stageColor(stage) {
  if (stage === "Closed") return "os-badge-green";
  if (stage === "Lost") return "os-badge-grey";
  if (stage === "New") return "os-badge-blue";
  if (stage === "Booking" || stage === "Loan Processing") return "os-badge-amber";
  return "os-badge-blue";
}

export function timeAgo(iso) {
  if (!iso) return "—";
  const now = Date.now();
  const t = new Date(iso).getTime();
  if (isNaN(t)) return "—";
  const s = Math.max(0, Math.floor((now - t) / 1000));
  if (s < 60) return `${s}s ago`;
  const m = Math.floor(s / 60);
  if (m < 60) return `${m}m ago`;
  const h = Math.floor(m / 60);
  if (h < 24) return `${h}h ago`;
  const d = Math.floor(h / 24);
  return `${d}d ago`;
}
